/**
 * Notification counter
 * Useful to keep state when navigation bar is destroyed
 */
export const notificationCount = ref(0)
